import Dashboard       from '../pages/prospect/Dashboard';
import Campanhas       from '../pages/prospect/Campanhas';
import CampanhaDetalhe from '../pages/prospect/CampanhaDetalhe';
import CampanhaWizard  from '../pages/prospect/CampanhaWizard';
import Listas          from '../pages/prospect/Listas';
import ListaDetalhe    from '../pages/prospect/ListaDetalhe';
import Conexoes        from '../pages/prospect/Conexoes';
import Conversas       from '../pages/prospect/Conversas';
import Agentes         from '../pages/prospect/Agentes';
import TimeComercial   from '../pages/prospect/TimeComercial';
import Configuracoes   from '../pages/prospect/Configuracoes';
export const routes = [
  { path: '/dashboard',              Component: <Dashboard /> },
  { path: '/campanhas',              Component: <Campanhas /> },
  { path: '/campanhas/nova',         Component: <CampanhaWizard /> },
  { path: '/campanhas/:id',          Component: <CampanhaDetalhe /> },
  { path: '/campanhas/:id/editar',   Component: <CampanhaWizard /> },
  { path: '/listas',                 Component: <Listas /> },
  { path: '/listas/:id',             Component: <ListaDetalhe /> },
  { path: '/conexoes',               Component: <Conexoes /> },
  { path: '/conversas',              Component: <Conversas /> },
  { path: '/agentes',                Component: <Agentes /> },
  { path: '/time',                   Component: <TimeComercial /> },
  { path: '/configuracoes',          Component: <Configuracoes /> },
];
